export default "__VITE_ASSET__BAewWcKo__"